import { z } from 'zod';

/** 스케줄 실행 이력 검색 폼 스키마 */
export const scheduleRunFilterSchema = z.object({
  taskName: z.string().optional(),
  status: z.enum(['', 'SUCCESS', 'FAILED', 'SKIPPED']).optional(),
  from: z.string().optional(),
  to: z.string().optional(),
});

export type ScheduleRunFilterForm = z.infer<typeof scheduleRunFilterSchema>;

/** 배치 트리거 파라미터 폼 스키마 */
export const triggerParamsSchema = z.object({
  runDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, '날짜 형식은 YYYY-MM-DD 여야 합니다')
    .optional()
    .or(z.literal('')),
});

export type TriggerParamsForm = z.infer<typeof triggerParamsSchema>;
